export enum InstitutionStatus {
  CREATED = 'CREATED',
  INSTITUTION_VALIDATION = 'INSTITUTION_VALIDATION',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  INACTIVE = 'INACTIVE',
}
